import { defineMessages } from 'react-intl';

export default defineMessages({
  products: 'Products',
  generalContractors: 'General Contractors',
  subcontractors: 'Subcontractors',
  resources: 'Resources',
  demo: 'Request Demo'
});
